import '../stylesheets/frontend/pair.css.scss'
import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'

import ReactOnRails from 'react-on-rails'
import PairMarketsTable from '../bundles/components/PairMarketsTable'
import ChatFrame from '../bundles/components/chat/ChatFrame'

const application = Application.start()
const context = require.context(
  'controllers',
  true,
  /^(?!.*\/admin\/).*_controller\.(js|ts)$/
)
application.load(definitionsFromContext(context))

ReactOnRails.register({
  PairMarketsTable,
  ChatFrame,
})
